import React from 'react';
import PropTypes from 'prop-types';

import {
  ReactComponent as Lightbulb,
} from '@pagerduty/design-system/dist/icons/lightbulb.svg';
import styles from './style.module.css';

const TipBox = props => (
  <aside className={styles.tipBox}>
    <div>
      <Lightbulb className={styles.tipBoxIcon} />
    </div>
    <div className={styles.tipBoxText}>
      {props.children}
    </div>
  </aside>
);

TipBox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TipBox;
